import {call, put, takeLatest} from 'redux-saga/effects';
import {
    USER_PREFERENCE_UPDATE_START,
    UserPreferenceUpdateStartAction,
    getUserPreferenceUpdateSuccessAction,
    getUserPreferenceUpdateFailedAction
} from "../actions/UserPreferenceAction";
import ApiUtil from "src/utils/ApiUtil";


export function* setUserPreference(action: UserPreferenceUpdateStartAction) {
    try {
        yield call(ApiUtil.postApiWithTimeout, "setuserpreference", action.userPreference);

        yield put(getUserPreferenceUpdateSuccessAction(action.userPreference));
    } catch (error) {
        console.error("Call API setuserpreference error" + error)
        yield put(getUserPreferenceUpdateFailedAction());
        return;
    }
}

export default function* userPreferenceUpdate() {
    yield takeLatest(USER_PREFERENCE_UPDATE_START, setUserPreference);
}
